import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

type Variant = 'primary' | 'quiet' | 'destructive';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  children: ReactNode;
};

export function Button({ variant = 'primary', children, ...rest }: ButtonProps) {
  return (
    <button type="button" className={`button button--${variant}`} {...rest}>
      {children}
    </button>
  );
}
